import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Popover',
  setup(__props) {

const isOpen = ref(false);
const popoverContainer = ref<HTMLElement | null>(null);
const popoverContent = ref<HTMLElement | null>(null);

function togglePopover() {
	isOpen.value = !isOpen.value;
}

function handleClickOutside(event: MouseEvent) {
	if (
		popoverContainer.value &&
		!popoverContainer.value.contains(event.target as Node) &&
		popoverContent.value &&
		!popoverContent.value.contains(event.target as Node)
	) {
		isOpen.value = false;
	}
}

onMounted(() => {
	document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
	document.removeEventListener('click', handleClickOutside);
});

return { __sfc: true,isOpen, popoverContainer, popoverContent, togglePopover, handleClickOutside }
}

})